import React from "react";

const ShapeImg = ({ color = "#fff" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="457"
            height="575"
            viewBox="0 0 457 575"
        >
            <path
                id="Differenzmenge_152"
                data-name="Differenzmenge 152"
                d="M457,575.194H0V.194H414.442a80.57,80.57,0,0,0-59.9,33.565L13.64,510.85a41.371,41.371,0,0,0-5.451,10.487,39.618,39.618,0,0,0-2.135,10.915,41.157,41.157,0,0,0,18.722,36.532,39.14,39.14,0,0,0,10.016,4.569A40.9,40.9,0,0,0,46.375,575L457,575v.195Z"
                transform="translate(0 -0.193)"
                fill={color}
            />
        </svg>
    );
};

export default ShapeImg;
